import React, { useEffect } from "react";
import classNames from "classnames";
import Toggle from "../sidebar/Toggle";
import Logo from "../logo/Logo";
import User from "./dropdown/user/User";
import Notification from "./dropdown/notification/Notification";
import HeaderSearch from "../header-search/HeaderSearch";
import ChatDropdown from "./dropdown/chat/Chat";

import {useHistory} from 'react-router-dom'

import { Card, Row, Col, Button, UncontrolledDropdown, DropdownMenu, DropdownItem, DropdownToggle } from "reactstrap";

import {useMediaQuery, useMediaQueries} from '@react-hook/media-query';
import useResponsive from "../../customHooks/useResponsive";
const Header = ({ fixed, theme, className, setVisibility, plainHeader, ...props }) => {

  const history = useHistory();
  

  const { isMobile } = useResponsive();
  const headerClass = classNames({
    "nk-header": true,
    "nk-header-fixed": fixed,
    [`is-light`]: theme === "white",
    [`is-${theme}`]: theme !== "white" && theme !== "light",
    [`${className}`]: className,
  });


  const handleLogInPage = () => {
    history.push('/auth-login')
  }
  
  const handleRegisterPage = () => {
    history.push('/auth-register')
  }

  return (
    <div className={headerClass}>      
      <div className="container-fluid">
        <div className="nk-header-wrap">
          {!plainHeader && <div className="nk-menu-trigger d-xl-none ml-n1">
            <Toggle
              className="nk-nav-toggle nk-quick-nav-icon d-xl-none ml-n1"
              icon="menu"
              click={props.sidebarToggle}
            />
          </div>
          }
          <div className="nk-header-brand d-xl-none">
            <Logo />
          </div>
          {/* {plainHeader == true && <Logo plainHeader={true} />} */}
          {/* {!plainHeader && <div className="nk-header-search ml-3 ml-xl-0">
            <HeaderSearch />
          </div>
          } */}

          <div className="nk-header-tools">



            {plainHeader == true && <>
            
              {isMobile ? <Button size="sm" color="primary" className="mr-2" onClick={handleLogInPage}>Log in</Button>
              : <Button color="primary" className="mr-2" onClick={handleLogInPage}>Log in</Button>}
            </>}
            {plainHeader == true && <>
            
              {isMobile ? <Button size="sm" color="primary" onClick={handleRegisterPage}>Register</Button>
              : <Button color="primary" onClick={handleRegisterPage}>Register</Button>
              }
            </>}
            {!plainHeader &&
              <ul className="nk-quick-nav">
                {/* <li className="chats-dropdown hide-mb-xs" onClick={() => setVisibility(false)}>
                  <ChatDropdown />
                </li> */}
                {/* <li className="notification-dropdown mr-n1" onClick={() => setVisibility(false)}>
                  <Notification />
                </li> */}
                <li className="user-dropdown" onClick={() => setVisibility(false)}>
                  <User />
                </li>
              </ul>
            }
          </div>

        </div>
      </div>
    </div>
  );
};
export default Header;
